import React from "react";
import compose from "recompose/compose";
import { defineMessages, useIntl } from "react-intl";
import Button from "theme/components/atoms/Button";
import EnhanceSubscribeToInStockAlert from "./EnhanceSubscribeToInStockAlert";
import LabelledIcon from "../../components/molecules/LabelledIcon";

const messages = defineMessages({
  subscribeToInStockAlert: {
    id: "modules.SubscribeToInStockAlert.subscribe.title",
    defaultMessage: "Notify me when the product is back in stock",
  },
  unsubscribeToInStockAlert: {
    id: "modules.SubscribeToInStockAlert.unsubscribe.title",
    defaultMessage: "Don't notify me when the product is back in stock anymore",
  },
});

const SubscribeToInStockAlert = ({
  sku,
  ensureLoggedIn,
  reloadIfNewLogin,
  loginModal,
  subscribeToInStockAlert,
  unsubscribeToInStockAlert,
  isSubscribedToInStockAlert,
  commandPending,
}) => {
  const intl = useIntl();

  return (
    <div className="subscribe-to-in-stock-alert">
      {loginModal}
      <Button
        state={commandPending ? "pending" : null}
        appearance="default"
        size="small"
        onClick={(event) => {
          ensureLoggedIn()
            .then(() => {
              if (isSubscribedToInStockAlert) {
                return unsubscribeToInStockAlert();
              } else {
                return subscribeToInStockAlert();
              }
            })
            .then(() => {
              reloadIfNewLogin();
            })
            .catch(() => {});
        }}
      >
        <LabelledIcon
          icon={
            isSubscribedToInStockAlert ? "notification-off" : "notification"
          }
        >
          {intl.formatMessage(
            isSubscribedToInStockAlert
              ? messages.unsubscribeToInStockAlert
              : messages.subscribeToInStockAlert
          )}
        </LabelledIcon>
      </Button>
    </div>
  );
};

export default compose(EnhanceSubscribeToInStockAlert())(
  SubscribeToInStockAlert
);
